import React from 'react'

const Skill = () => {
    return(
        <div className="wpo-about-item">
            <div className="row">
                <div className="col-lg-12">
                    <div className="wpo-counter-grids">
                        <div className="grid">
                            <div>
                                <h2><span className="odometer" data-count="75">90</span>%</h2>
                            </div>
                            <p>Communication Skills</p>
                        </div>
                        <div className="grid">
                            <div>
                                <h2><span className="odometer" data-count="90">90</span>%</h2>
                            </div>
                            <p>Project Management</p>
                        </div>
                        <div className="grid">
                            <div>
                                <h2><span className="odometer" data-count="65">65</span>%</h2>
                            </div>
                            <p>Problem Solving</p>
                        </div>
                        <div className="grid">
                            <div>
                                <h2><span className="odometer" data-count="55">55</span>%</h2>
                            </div>
                            <p>Analitical Abilities</p>
                        </div>
                        <div className="grid">
                            <div>
                                <h2><span className="odometer" data-count="43">43</span>%</h2>
                            </div>
                            <p>Organization</p>
                        </div>
                        <div className="grid">
                            <div>
                                <h2><span className="odometer" data-count="82">82</span>%</h2>
                            </div>
                            <p>Creativity</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Skill;